.signet-list-container {
  background-color: var(--pure-white);
  width: 400px;
}
